"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePool = exports.parseStakingPool = exports.parsePoolSnapshots = exports.getNewStakingInfo = exports.getPoolUpdate = exports.getStakingPools = exports.getPoolSnapshots = exports.getTokenPrice = exports.getPool = exports.getPools = void 0;
var subgraph_clients_1 = require("@indexed-finance/subgraph-clients");
var bmath = __importStar(require("./bmath"));
function getPools(network) {
    return __awaiter(this, void 0, void 0, function () {
        var client, indexPools;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = subgraph_clients_1.IndexedCoreSubgraphClient.forNetwork(network);
                    return [4 /*yield*/, client.getAllIndexPools()];
                case 1:
                    indexPools = _a.sent();
                    return [2 /*return*/, indexPools.map(exports.parsePool)];
            }
        });
    });
}
exports.getPools = getPools;
function getPool(network, address) {
    return __awaiter(this, void 0, void 0, function () {
        var client, indexPool, pool;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = subgraph_clients_1.IndexedCoreSubgraphClient.forNetwork(network);
                    return [4 /*yield*/, client.getIndexPool(address)];
                case 1:
                    indexPool = _a.sent();
                    pool = exports.parsePool(indexPool);
                    return [2 /*return*/, pool];
            }
        });
    });
}
exports.getPool = getPool;
var toBaseToken = function (t) { return ({
    address: t.token.id,
    balance: bmath.bnum(t.balance),
    decimals: +(t.token.decimals),
    name: t.token.name,
    symbol: t.token.symbol,
    priceUSD: +(t.token.priceUSD)
}); };
// const tokenDayDataQuery = (tokenAddress, days) => `
// {
// tokenDayDatas(orderBy: date, orderDirection: desc, first: ${days}, where: { token: "${tokenAddress}" }) {
// date
// priceUSD
// }
// }
// `
function getTokenPrice(network, address) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, bmath.bnum(0)];
        });
    });
}
exports.getTokenPrice = getTokenPrice;
function getPoolSnapshots(network, poolAddress, days) {
    return __awaiter(this, void 0, void 0, function () {
        var client, dailyPoolSnapshots;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = subgraph_clients_1.IndexedCoreSubgraphClient.forNetwork(network);
                    return [4 /*yield*/, client.getPoolSnapshots(poolAddress, days)];
                case 1:
                    dailyPoolSnapshots = _a.sent();
                    return [2 /*return*/, exports.parsePoolSnapshots(dailyPoolSnapshots)];
            }
        });
    });
}
exports.getPoolSnapshots = getPoolSnapshots;
function getStakingPools(network) {
    return __awaiter(this, void 0, void 0, function () {
        var client, ndxStakingPools;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = subgraph_clients_1.IndexedCoreSubgraphClient.forNetwork(network);
                    return [4 /*yield*/, client.getAllStakingPools()
                        // const { ndxStakingPools } = await executeQuery(stakingQuery(), url);
                    ];
                case 1:
                    ndxStakingPools = _a.sent();
                    // const { ndxStakingPools } = await executeQuery(stakingQuery(), url);
                    return [2 /*return*/, ndxStakingPools.map(exports.parseStakingPool)];
            }
        });
    });
}
exports.getStakingPools = getStakingPools;
function getPoolUpdate(network, address) {
    return __awaiter(this, void 0, void 0, function () {
        var client, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = subgraph_clients_1.IndexedCoreSubgraphClient.forNetwork(network);
                    return [4 /*yield*/, client.getPoolUpdate(address)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, {
                            snapshot: __assign(__assign({}, result.snapshot), { totalSupply: +result.snapshot.totalSupply }),
                            tokenPrices: result.tokenPrices
                        }];
            }
        });
    });
}
exports.getPoolUpdate = getPoolUpdate;
exports.getNewStakingInfo = function (network) { return __awaiter(void 0, void 0, void 0, function () {
    var client;
    return __generator(this, function (_a) {
        client = subgraph_clients_1.IndexedStakingSubgraphClient.forNetwork(network);
        return [2 /*return*/, client.getStakingInfo()];
    });
}); };
exports.parsePoolSnapshots = function (snapshots_) {
    var snapshots = snapshots_.reverse();
    var retArr = [];
    var snapshot0 = snapshots[0];
    var lastDate = +(snapshot0.date);
    var lastSwapVolumeTotal = snapshot0.totalSwapVolumeUSD;
    var lastVolumeTotal = snapshot0.totalVolumeUSD;
    var lastFeesTotal = snapshot0.feesTotalUSD;
    var lastSupply = +(snapshot0.totalSupply);
    var lastValue = snapshot0.value;
    var lastTotalValue = snapshot0.totalValueLockedUSD;
    if (snapshots_.length == 1) {
        retArr.push({
            date: lastDate,
            value: snapshot0.value,
            totalSupply: +(snapshot0.totalSupply),
            dailyFeesUSD: lastFeesTotal,
            totalVolumeUSD: lastVolumeTotal,
            totalValueLockedUSD: snapshot0.totalValueLockedUSD,
            dailySwapVolumeUSD: lastSwapVolumeTotal
        });
    }
    else {
        for (var _i = 0, _a = snapshots.slice(1); _i < _a.length; _i++) {
            var snapshot = _a[_i];
            var date = snapshot.date, value = snapshot.value, totalSupply = snapshot.totalSupply, feesTotalUSD = snapshot.feesTotalUSD, totalValueLockedUSD = snapshot.totalValueLockedUSD, totalSwapVolumeUSD = snapshot.totalSwapVolumeUSD, totalVolumeUSD = snapshot.totalVolumeUSD;
            var dailyFeesUSD = (+feesTotalUSD) - lastFeesTotal;
            var dailySwapVolumeUSD = (+totalSwapVolumeUSD) - lastSwapVolumeTotal;
            var dailyVolumeUSD = (+totalVolumeUSD) - lastVolumeTotal;
            var diff = (+date) - (lastDate);
            if (diff > 3600) {
                var numHours = (diff / 3600) - 1;
                var feesEachHour = dailyFeesUSD / numHours;
                var swapVolumeEachHour = dailySwapVolumeUSD / numHours;
                var supplyEachHour = (+totalSupply - lastSupply) / numHours;
                var volumeEachHour = dailyVolumeUSD / numHours;
                var valueEachHour = (+value - lastValue) / numHours;
                var tvlEachHour = (+totalValueLockedUSD - lastTotalValue) / numHours;
                for (var i = 1; i <= numHours; i++) {
                    retArr.push({
                        date: lastDate + (3600 * i),
                        value: lastValue + (valueEachHour * i),
                        totalSupply: lastSupply + (supplyEachHour * i),
                        dailyFeesUSD: (feesEachHour * i),
                        totalValueLockedUSD: lastTotalValue + (tvlEachHour * i),
                        dailySwapVolumeUSD: (swapVolumeEachHour * i),
                        totalVolumeUSD: (volumeEachHour * i)
                    });
                }
            }
            lastFeesTotal = +feesTotalUSD;
            lastSwapVolumeTotal = +totalSwapVolumeUSD;
            lastVolumeTotal = +totalVolumeUSD;
            lastSupply = +totalSupply;
            lastValue = +value;
            lastDate = +date;
            lastTotalValue = +totalValueLockedUSD;
            retArr.push({
                date: +date,
                value: +value,
                totalSupply: +totalSupply,
                dailyFeesUSD: +dailyFeesUSD,
                totalValueLockedUSD: +totalValueLockedUSD,
                dailySwapVolumeUSD: +dailySwapVolumeUSD,
                totalVolumeUSD: +dailyVolumeUSD
            });
        }
    }
    retArr.sort(function (a, b) { return a.date - b.date; });
    return retArr;
};
exports.parseStakingPool = function (data) {
    var periodStart = data.startsAt;
    var periodFinish = data.periodFinish;
    var lastUpdateTime = data.lastUpdateTime;
    var timestamp = new Date().getTime() / 1000;
    return {
        address: data.id,
        indexPool: data.indexPool,
        stakingToken: data.stakingToken,
        isWethPair: data.isWethPair,
        periodStart: periodStart,
        periodFinish: periodFinish,
        lastUpdateTime: lastUpdateTime,
        totalRewards: bmath.bnum(data.totalRewards),
        claimedRewards: bmath.bnum(data.claimedRewards),
        rewardRate: bmath.bnum(data.rewardRate),
        rewardPerToken: bmath.bnum(data.rewardPerTokenStored),
        totalSupply: bmath.bnum(data.totalSupply),
        isReady: data.isReady || timestamp >= periodStart,
        hasBegun: data.isReady,
        active: data.isReady && periodFinish > lastUpdateTime
    };
};
exports.parsePool = function (p) {
    var obj = {
        category: p.category.id,
        address: p.id,
        name: p.name,
        symbol: p.symbol,
        size: p.size,
        isPublic: p.isPublic,
        totalSupply: bmath.bnum(p.totalSupply),
        totalVolumeUSD: bmath.bnum(p.totalVolumeUSD),
        totalWeight: bmath.bnum(p.totalWeight),
        swapFee: p.isPublic ? bmath.scale(bmath.bnum(p.swapFee), 18) : bmath.bnum(0),
        exitFee: bmath.scale(bmath.bnum(p.exitFee), 18)
    };
    if (p.isPublic) {
        var tokenIndices_1 = p.tokensList.reduce(function (tks, address, i) {
            var _a;
            return (__assign(__assign({}, tks), (_a = {}, _a[address] = i, _a)));
        }, {});
        obj.feesTotalUSD = p.feesTotalUSD;
        obj.totalValueLockedUSD = p.totalValueLockedUSD;
        obj.totalSwapVolumeUSD = p.totalSwapVolumeUSD;
        obj.tokens = new Array(p.tokens.length).fill(null);
        obj.initializer = p.poolInitializer.id;
        obj.snapshots = exports.parsePoolSnapshots(p.dailySnapshots);
        p.tokens.forEach(function (t) {
            var token = __assign(__assign({}, toBaseToken(t)), { ready: t.ready, balance: bmath.bnum(t.balance), usedBalance: t.ready ? bmath.bnum(t.balance) : bmath.bnum(t.minimumBalance), weight: bmath.scale(bmath.bnum(t.denorm).div(obj.totalWeight), 18), denorm: bmath.bnum(t.denorm), desiredWeight: bmath.scale(bmath.bnum(t.desiredDenorm).div(obj.totalWeight), 18), desiredDenorm: bmath.bnum(t.desiredDenorm) });
            if (token.ready) {
                token.usedDenorm = token.denorm;
                token.usedWeight = token.weight;
            }
            else {
                token.usedDenorm = bmath.MIN_WEIGHT;
                token.usedWeight = bmath.bnum(bmath.MIN_WEIGHT).div(obj.totalWeight);
            }
            if (t.minimumBalance) {
                token.minimumBalance = bmath.bnum(token.usedBalance);
            }
            var index = tokenIndices_1[token.address];
            obj.tokens[index] = token;
        });
    }
    else {
        obj.initializer = {
            address: p.poolInitializer.id,
            pool: obj.address,
            totalCreditedWETH: bmath.bnum(p.poolInitializer.totalCreditedWETH),
            tokens: []
        };
        p.poolInitializer.tokens.forEach(function (t) {
            obj.initializer.tokens.push(__assign(__assign({}, toBaseToken(t)), { targetBalance: bmath.bnum(t.targetBalance), amountRemaining: bmath.bnum(t.amountRemaining) }));
        });
    }
    return obj;
};
